import Logger from 'wanderu-logger';

import { actions as cgActions } from '../../appstate/carrierGuide';
import { getCarrierGuide } from '../../services/seoService';
import {
    actions,
    reducer,
    selectors,
    namespace,
} from './base';

const logger = Logger.getLogger(namespace);

function fetchCarrierGuide(localeAwareCarrierGuideId, carrierGuideId, locale) {
    return async function(dispatch) {
        let error = null;

        dispatch(actions.startWork(localeAwareCarrierGuideId));

        try {
            const { result } = await getCarrierGuide({ carrierGuideId, locale });

            if (!result.carriers.length) {
                error = new Error('NO_CARRIER_FOUND');
                error.code = 'NO_CARRIER_FOUND';
                error.responseBody = {
                    error: {
                        status: 404,
                    },
                };

                throw error;
            }

            dispatch(cgActions.setCarrierGuideContent(result, localeAwareCarrierGuideId));
            return result;
        } catch (ex) {
            logger.warn('fetchCarrierGuide', ex, localeAwareCarrierGuideId);

            error = {
                code: ex.code,
                message: 'set carrier guide failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(localeAwareCarrierGuideId, undefined, error));
        }
    };
}

function clearCarrierGuide(localeAwareCarrierGuideId) {
    return (dispatch) => {
        dispatch(actions.reset(localeAwareCarrierGuideId));
        dispatch(cgActions.clearCarrierGuideContent(localeAwareCarrierGuideId));
    };
}

const fetchCarrierGuideSelectors = {
    ...selectors,
    selectNotFound(appState, id) {
        const opStatus = selectors.idSelector(appState, id);

        return opStatus
            && opStatus.error
            && ['INVALID_CARRIER_GUIDE_ID', 'NO_CARRIER_FOUND'].includes(opStatus.error.code);
    },
};

const fetchCarrierGuideAction = {
    clearCarrierGuide,
    fetchCarrierGuide,
    ...fetchCarrierGuideSelectors,
};

export {
    fetchCarrierGuideAction,
    namespace,
};

export default {
    [namespace]: reducer,
};
